import React, { forwardRef, memo } from 'react'

const TrophyIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="266"
      height="175.7"
      viewBox="0 0 380 251"
      fill="none"
      {...props}>
      <path
        d="M217.074 224.209H362.706V244.13C362.706 247.924 359.63 251 355.837 251H223.944C220.15 251 217.074 247.924 217.074 244.13V224.209Z"
        fill="#D15A19"
      />
      <path
        d="M362.706 224.209C362.706 226.865 330.105 229.018 289.89 229.018C249.675 229.018 217.074 226.865 217.074 224.209C217.074 221.553 249.675 219.4 289.89 219.4C330.105 219.4 362.706 221.553 362.706 224.209Z"
        fill="#FFA300"
      />
      <path d="M251.422 229.704V250.312" stroke="white" />
      <path d="M290.577 229.704V250.312" stroke="white" />
      <path d="M329.046 229.704V250.312" stroke="white" />
      <path
        d="M233.561 198.105H379.193V218.027C379.193 221.821 376.117 224.896 372.323 224.896H240.43C236.637 224.896 233.561 221.821 233.561 218.027V198.105Z"
        fill="#D15A19"
      />
      <path
        d="M379.193 198.105C379.193 200.761 346.592 202.914 306.377 202.914C266.162 202.914 233.561 200.761 233.561 198.105C233.561 195.45 266.162 193.297 306.377 193.297C346.592 193.297 379.193 195.45 379.193 198.105Z"
        fill="#FFA300"
      />
      <path d="M267.908 203.602V224.21" stroke="white" />
      <path d="M307.064 203.602V224.21" stroke="white" />
      <path d="M345.533 203.602V224.21" stroke="white" />
      <path
        d="M124.191 132.611C111.181 132.611 100.68 128.487 92.6868 120.239C84.7787 111.991 80.8247 100.894 80.8247 86.9486C80.8247 71.7278 85.0338 59.6531 93.4521 50.7247C101.955 41.7962 113.265 37.332 127.38 37.332C140.9 37.332 151.444 41.3711 159.012 49.4492C166.665 57.5273 170.492 68.8792 170.492 83.5048C170.492 98.5556 166.283 110.503 157.864 119.346C149.446 128.19 138.222 132.611 124.191 132.611ZM126.615 59.7807C114.2 59.7807 107.993 68.4115 107.993 85.6731C107.993 101.999 113.902 110.163 125.722 110.163C137.797 110.163 143.834 101.659 143.834 84.6528C143.834 68.0714 138.094 59.7807 126.615 59.7807ZM257.735 39.883L138.604 222.789H107.482L226.358 39.883L251.412 26.7646L257.735 39.883ZM238.093 225.34C225.083 225.34 214.581 221.215 206.588 212.967C198.68 204.719 194.726 193.622 194.726 179.677C194.726 164.456 198.935 152.381 207.354 143.453C215.857 134.524 227.166 130.06 241.282 130.06C254.887 130.06 265.473 134.057 273.041 142.05C280.609 150.043 284.393 161.352 284.393 175.978C284.393 191.029 280.184 203.018 271.766 211.947C263.348 220.875 252.123 225.34 238.093 225.34ZM240.134 152.509C227.804 152.509 221.639 161.14 221.639 178.401C221.639 194.728 227.634 202.891 239.623 202.891C251.698 202.891 257.735 194.388 257.735 177.381C257.735 169.473 256.12 163.351 252.889 159.014C249.657 154.677 245.406 152.509 240.134 152.509Z"
        fill="#78BE20"
      />
      <path
        d="M100.45 209.429L107.482 222.789H127.623L131.397 209.429H100.45Z"
        fill="#78BE20"
      />
      <path
        d="M117.557 119.589C104.547 119.589 94.0451 115.465 86.052 107.217C78.144 98.9684 74.1899 87.8716 74.1899 73.9262C74.1899 58.7053 78.3991 46.6307 86.8173 37.7022C95.3206 28.7738 106.63 24.3096 120.745 24.3096C134.266 24.3096 144.81 28.3486 152.378 36.4267C160.031 44.5049 163.857 55.8567 163.857 70.4824C163.857 85.5332 159.648 97.4803 151.23 106.324C142.811 115.167 131.587 119.589 117.557 119.589ZM119.98 46.7582C107.565 46.7582 101.358 55.3891 101.358 72.6507C101.358 88.977 107.268 97.1402 119.087 97.1402C131.162 97.1402 137.199 88.6369 137.199 71.6303C137.199 55.0489 131.46 46.7582 119.98 46.7582ZM251.413 26.8605L131.97 209.766L100.451 209.43L219.724 26.8605H251.413ZM231.458 212.317C218.448 212.317 207.947 208.193 199.953 199.945C192.045 191.697 188.091 180.6 188.091 166.654C188.091 151.434 192.3 139.359 200.719 130.43C209.222 121.502 220.531 117.038 234.647 117.038C248.252 117.038 258.839 121.034 266.407 129.027C273.975 137.021 277.758 148.33 277.758 162.956C277.758 178.006 273.549 189.996 265.131 198.924C256.713 207.853 245.489 212.317 231.458 212.317ZM233.499 139.486C221.169 139.486 215.004 148.117 215.004 165.379C215.004 181.705 220.999 189.868 232.989 189.868C245.063 189.868 251.101 181.365 251.101 164.359C251.101 156.451 249.485 150.328 246.254 145.991C243.023 141.655 238.771 139.486 233.499 139.486Z"
        fill="#CEDC00"
      />
      <circle
        cx="60.736"
        cy="188.315"
        r="48.317"
        transform="rotate(-17.729 60.736 188.315)"
        fill="#D15A19"
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="12"
        y="139"
        width="98"
        height="98">
        <circle
          cx="60.736"
          cy="188.317"
          r="48.317"
          transform="rotate(-17.729 60.736 188.317)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M11.8032 179.983L32.0243 173.519"
          stroke="white"
          strokeWidth="1.988"
        />
        <path
          d="M32.0093 229.24L52.2303 222.776"
          stroke="white"
          strokeWidth="1.988"
        />
        <path
          d="M10.0967 209.501L35.373 201.42"
          stroke="white"
          strokeWidth="1.988"
        />
      </g>
      <ellipse
        cx="69.466"
        cy="186.06"
        rx="44.582"
        ry="48.827"
        transform="rotate(-17.729 69.466 186.06)"
        fill="#FFA300"
      />
      <circle
        cx="312.789"
        cy="52.394"
        r="38.365"
        transform="rotate(152.749 312.789 52.394)"
        fill="#D15A19"
      />
      <mask
        id="mask1"
        maskUnits="userSpaceOnUse"
        x="274"
        y="14"
        width="78"
        height="77">
        <circle
          cx="312.789"
          cy="52.393"
          r="38.365"
          transform="rotate(152.749 312.789 52.393)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask1)">
        <path
          d="M352.202 52.4922L337.217 60.2105"
          stroke="white"
          strokeWidth="1.988"
        />
        <path
          d="M329.91 16.5732L314.924 24.2916"
          stroke="white"
          strokeWidth="1.988"
        />
        <path
          d="M349.662 29.1533L330.93 38.8013"
          stroke="white"
          strokeWidth="1.988"
        />
      </g>
      <ellipse
        cx="306.248"
        cy="55.307"
        rx="35.399"
        ry="38.77"
        transform="rotate(152.749 306.248 55.307)"
        fill="#FFA300"
      />
    </svg>
  )
)

TrophyIcon.displayName = 'TrophyIcon'

export default memo(TrophyIcon)
